import { createSlice } from '@reduxjs/toolkit';
import authRoles from './authRoles';

const initialState = {
    user: null,
    roles: ['isBasic'],
    isAdmin: false,
    isCoder: false,
    isCV: false,
    isVideoClient: false,
    features: null
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUser(state, action) {
            state.user = action.payload;
            if (action.payload === null) {
                state.roles = ['isBasic'];
                // Reset all role flags
                state.isAdmin = false;
                state.isCoder = false;
                state.isCV = false;
                state.isVideoClient = false;
            } else {
                const userData = action.payload;
                
                // Extract roles from Auth0 custom claims or user metadata
                const userRoles = userData['https://goldensetanalytics.com/roles'] || 
                                userData.roles || 
                                userData['custom:roles'] || 
                                userData.app_metadata?.roles ||
                                [];
                
                // Ensure user object has roles property
                state.user.roles = userRoles;
                
                // Set user ID for New Relic (use email or sub)
                if (typeof newrelic !== 'undefined') {
                    newrelic.setUserId(userData.preferred_username || userData.email);
                }

                // Process roles
                for (const [key, value] of Object.entries(authRoles)) {
                    for (const role of userRoles) {
                        if (value.includes(role)) {
                            state.roles.push(key);
                            state[key] = true;
                        }
                    }
                }
            }
        },
        setFeatures(state, action) {
            state.features = action.payload;
        }
    },
});

export const { setUser, setFeatures } = authSlice.actions;
export const selectUser = (state) => state.auth.user;
export const selectRoles = (state) => state.auth.roles;
export const selectIsAdmin = (state) => state.auth.isAdmin;
export const selectIsCoder = (state) => state.auth.isCoder;
export const selectIsCV = (state) => state.auth.isCV;
export const selectIsVideoClient = (state) => state.auth.isVideoClient;
export const selectIsAllowedPostMatchReport = (state) => state.auth.features ? state.auth.features.some(f => f.name == 'Post Match Report') : null;
export const selectIsAllowedShotEvolutionReport = (state) => state.auth.features ? state.auth.features.some(f => f.name == 'Shot Evolution Report') : null;
export const selectIsAllowedShotsPlayer = (state) => state.auth.features ? state.auth.features.some(f => f.name == 'Shots Player') : null;
export const selectIsAllowedReportGeneration = (state) => state.auth.features ? state.auth.features.some(f => f.name == 'Report Generation') : null;
export const selectIsAllowedDoublesPlayer = (state) => state.auth.features ? state.auth.features.some(f => f.name == 'Doubles Player') : null;

export default authSlice.reducer;